<template>
	<div class="grid grid-cols-2 break-words leading-none mb-2 max-w-full w-full">
		<div v-if="!icon && !showIconSpace" class="font-bold">{{ label || missingLabel }}:</div>
		<div :class="{ 'text-red-300': missingValueRed, 'col-span-2': icon || showIconSpace }" class="flex space-x-4">
			<div class="w-5" v-if="icon || showIconSpace">
				<font-awesome-icon :icon="icon" class="text-gray-500 text-sm" v-if="icon" />
			</div>
			<div>
				{{ value || missingValue }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BaseCardRow',
	props: {
		value: { default: '', required: true },
		label: {},
		icon: { type: String, default: null },
		showIconSpace: { type: Boolean, default: false },
		missingLabel: {},
		missingValue: { default: '-' },
		missingValueRed: { default: false },
	},
};
</script>

<style scoped></style>
